import type { ListQuery, PaginatedMetadata } from '@/types'
import i18n from '@/i18n'

// Sane default page size for server-side paginated lists.
export const DEFAULT_PAGE_SIZE = 20

// Selectable page sizes for the pagination page-size selector.
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100] as const

// Cap for server-side search-as-you-type pickers (never fetch-all).
export const PICKER_LIMIT = 20

// Normalize a list query with sane defaults (page + limit map directly to the
// seed `page`/`limit` params).
export function withListDefaults(query: ListQuery = {}): ListQuery {
  return {
    page: query.page ?? 1,
    limit: query.limit ?? DEFAULT_PAGE_SIZE,
    ...query,
  }
}

// Build the "Showing A-B of N" label from envelope metadata.
export function showingRangeLabel(meta: PaginatedMetadata | undefined): string {
  if (!meta || meta.total === 0) return i18n.t('errors:list.showingEmpty')
  const from = meta.from ?? 0
  const to = meta.to ?? 0
  return i18n.t('errors:list.showingRange', { from, to, total: meta.total })
}
